export const locale = {
    lang: 'en',
    data: {
        EXPORT_BOARD: 'Export to a board',
        EXPORT: 'Export',
        SAVE: 'Cancel',
    }
};
